module.exports = __webpack_public_path__ + "img/northen-cyprus.9381052d.png";